export const CHALLENGE_TITLE = {
  minLength: 3,
  maxLength: 255
};
